module.exports = __webpack_public_path__ + "img/img-magic-4-b-05-img-01.30c275a8.png";